import { render, staticRenderFns } from "./ProductVariantTitle.vue?vue&type=template&id=d19ef392&scoped=true&"
import script from "./ProductVariantTitle.vue?vue&type=script&lang=js&"
export * from "./ProductVariantTitle.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantTitle.vue?vue&type=style&index=0&id=d19ef392&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19ef392",
  null
  
)

export default component.exports